import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "flex-desktop",
  style: {"justify-content":"space-between","align-items":"center"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Basic information"),
  /*#__PURE__*/_createElementVNode("p", null, "Be descriptive and name your event.")
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "container" }

import { save, close } from "ionicons/icons";
import {
  IonLabel,
  IonItem,
  IonList,
  IonGrid,
  IonButton,
  IonLoading,
  IonIcon,
  IonTextarea,
  IonRow,
  IonCol,
  IonInput,
  IonFooter,
  IonNote,
  useIonRouter,
  IonAlert,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";
import { onMounted, reactive } from "vue";
import { editEvent, deleteEvent } from "@/api/events";
import { useToasters } from "@/composition/toasters";
import { useUserStore } from "@/stores/user";
import { handleError } from "@/views";
import { useWindowWidth } from "@/composition/window";
import { event as gtag_event } from "vue-gtag";


export default /*#__PURE__*/_defineComponent({
  __name: 'Details',
  emits: ["cancel"],
  setup(__props, { emit }) {

const { isMobile } = useWindowWidth();
const toasters = useToasters();
const contextStore = useContextStore();


const router = useIonRouter();
const userStore = useUserStore();

const event = reactive({
  name: "",
  slug: "",
  location: "",
  description: "",
  capacity: 100,
});

const state = reactive({
  loading: true,
  errors: {
    name: [],
    slug: [],
    capacity: [],
    start_date: [],
    end_date: [],
    timezone: [],
  },
  alertDeleteEvent: false,
});

const loadLocalEvent = () => {
  event.name = contextStore.event.name;
  event.description = contextStore.event.description || "";
  event.slug = contextStore.event.slug;
  event.location = contextStore.event.location;
  event.capacity = contextStore.event.capacity;
};

const submit = () => {
  state.loading = true;
  editEvent({ id: contextStore.event.id, ...event })
    .then(() => {
      state.loading = false;
      toasters.addSuccess("Event info saved successfuly");

      if (isMobile) {
        cancel();
      }
    })
    .catch((err) => {
      state.loading = false;
      if (err.response.data && err.response.data[0]) {
        toasters.addError(err.response.data[0]);
      } else {
        handleError(err);
      }
    });
};

const cancel = () => {
  emit("cancel", null);
};

onMounted(() => {
  userStore.getUserPermissions();
  loadLocalEvent();
  state.loading = false;
});

const deleteButtons = [
  {
    text: "Cancel",
    role: "cancel",
    cssClass: "alert-button-cancel",
    handler: () => {
      state.alertDeleteEvent = false;
    },
  },
  {
    text: " OK ",
    role: "confirm",
    cssClass: "alert-button-confirm",
    handler: () => {
      state.alertDeleteEvent = false;
      deleteEventById(contextStore.event.id);
    },
  },
];

const deleteEventById = (event_id: number) => {
  state.loading = true;
  deleteEvent(event_id)
    .then(() => {
      state.loading = false;
      router.push("/home");
      toasters.addSuccess("Event deleted successfully");
      userStore.fetchMe();

      gtag_event("event_deleted", {
        category: "check-in app",
        label: "Event deleted",
      });
    })
    .catch((err) => {
      state.loading = false;
      if (err.response.data && err.response.data[0]) {
        toasters.addError(err.response.data[0]);
      } else {
        handleError(err);
      }
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IonItem), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonLabel), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              (!_unref(isMobile) && _unref(userStore).userIsAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      color: "danger",
                      class: "ion-margin",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (state.alertDeleteEvent = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" DELETE EVENT ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonList), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), {
              position: "stacked",
              class: _normalizeClass({ 'ion-invalid': state.errors.name.length > 0 })
            }, {
              default: _withCtx(() => [
                _createTextVNode("Name")
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_unref(IonInput), {
              modelValue: event.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((event.name) = $event)),
              placeholder: "My event"
            }, null, 8, ["modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.name, (message, i) => {
              return (_openBlock(), _createBlock(_unref(IonNote), {
                slot: "error",
                key: `slug-error-${i}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(message), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), { position: "stacked" }, {
              default: _withCtx(() => [
                _createTextVNode("Slug")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonInput), {
              modelValue: event.slug,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((event.slug) = $event)),
              placeholder: "my-event"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), {
          class: _normalizeClass({ 'ion-invalid': state.errors.slug.length > 0 })
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), { position: "stacked" }, {
              default: _withCtx(() => [
                _createTextVNode("Description")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTextarea), {
              modelValue: event.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((event.description) = $event)),
              style: _normalizeStyle(_unref(isMobile) ? '' : 'min-height: 120px;'),
              placeholder: "Be descriptive and detailed!"
            }, null, 8, ["modelValue", "style"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.slug, (message, i) => {
              return (_openBlock(), _createBlock(_unref(IonNote), {
                slot: "error",
                key: `slug-error-${i}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(message), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_unref(IonItem), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), { position: "stacked" }, {
              default: _withCtx(() => [
                _createTextVNode("Location")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonInput), {
              placeholder: "New York",
              modelValue: event.location,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((event.location) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), {
          class: _normalizeClass({ 'ion-invalid': state.errors.capacity.length > 0 })
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), { position: "stacked" }, {
              default: _withCtx(() => [
                _createTextVNode("Capacity")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonInput), {
              modelValue: event.capacity,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((event.capacity) = $event)),
              type: "number",
              placeholder: "1000"
            }, null, 8, ["modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.capacity, (message, i) => {
              return (_openBlock(), _createBlock(_unref(IonNote), {
                slot: "error",
                key: `capacity-error-${i}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(message), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonLoading), {
      "is-open": state.loading,
      message: "Please wait..."
    }, null, 8, ["is-open"]),
    (_unref(isMobile) && _unref(userStore).userIsAdmin)
      ? (_openBlock(), _createBlock(_unref(IonButton), {
          key: 0,
          expand: "block",
          color: "primary",
          class: "ion-margin",
          fill: "clear",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (state.alertDeleteEvent = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" DELETE EVENT ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonAlert), {
      isOpen: state.alertDeleteEvent,
      buttons: deleteButtons,
      header: "Are you sure?",
      message: "This will permanently delete your event."
    }, null, 8, ["isOpen"]),
    (!_unref(isMobile))
      ? (_openBlock(), _createBlock(_unref(IonButton), {
          key: 1,
          style: {"margin":"20px auto","width":"200px"},
          expand: "block",
          color: "success",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (submit()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), {
              slot: "start",
              icon: _unref(save)
            }, null, 8, ["icon"]),
            _createTextVNode(" Save ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonLoading), {
      "is-open": state.loading,
      message: "Please wait..."
    }, null, 8, ["is-open"]),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("section", null, [
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonButton), {
                              expand: "block",
                              color: "light",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (cancel()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(close)
                                }, null, 8, ["icon"]),
                                _createTextVNode(" Cancel ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonButton), {
                              expand: "block",
                              color: "success",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (submit()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  icon: _unref(save)
                                }, null, 8, ["icon"]),
                                _createTextVNode(" Save ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})